export default function PHP_fetch_object() {
  return (
    <div>
      <h1>PHP_fetch_object</h1>
    </div>
  );
}
